import React from "react";
import { FormattedMessage } from "react-intl";

class Navigation extends React.Component {

    scrollToElement(element) {
        switch (element) {
            case "logistics":
                this.props.sectionRefs.logisticsRef.current.scrollIntoView();
                break;
            case "transport":
                this.props.sectionRefs.transportRef.current.scrollIntoView();
                break;
            case "warehousing":
                this.props.sectionRefs.warehousingRef.current.scrollIntoView();
                break;
            case "contacts":
                this.props.sectionRefs.contactsRef.current.scrollIntoView();
                break;

            default:
                break;
        }
    }

    render() {
        return (
            <div className="page-nav">
                <div className="page-nav-wrapper">
                    <p className="page-buttons" onClick={() => this.scrollToElement("logistics")}>
                        <img className="page-nav-image" src="./logistics.png" alt="Logistics"></img>
                        <FormattedMessage id="Company.navLogistics"
                            defaultMessage="Logistics"
                            description="Company Logistics Service" />
                    </p>
                    <p className="page-buttons" onClick={() => this.scrollToElement("transport")}>
                        <img className="page-nav-image" src="./transport.png" alt="Transport"></img>
                        <FormattedMessage id="Company.navTransport"
                            defaultMessage="Transport"
                            description="Transport Service" />
                    </p>
                    <p className="page-buttons" onClick={() => this.scrollToElement("warehousing")}>
                        <img className="page-nav-image" src="./warehousing.png" alt="Warehousing"></img>
                        <FormattedMessage id="Company.navWarehousing"
                            defaultMessage="Warehousing"
                            description="Warehousing Service" />
                    </p>
                    <p className="page-buttons" onClick={() => this.scrollToElement("contacts")}>
                        <img className="page-nav-image" src="./contacts.png" alt="Contacts"></img>
                        <FormattedMessage id="Company.navContacts"
                            defaultMessage="Contacts"
                            description="Contacts" />
                    </p>
                </div>
            </div>
        );
    }

}

export default Navigation;